import SectionLabel from "@/components/SectionLabel";

const sundayMasses = [
  { time: "6:00 AM", label: "Cebuano Mass" },
  { time: "8:00 AM", label: "English Mass" },
  { time: "9:30 AM", label: "Baptism" },
  { time: "3:00 PM", label: "Ilonggo Mass" },
  { time: "5:00 PM", label: "English Mass" },
];

const dailyMasses = [
  { day: "Monday", time: "6:00 AM" },
  { day: "Tuesday", time: "No Mass Schedule", note: true },
  { day: "Wednesday", time: "6:00 AM · 5:30 PM" },
  { day: "Thursday", time: "6:00 AM" },
  { day: "Friday", time: "6:00 AM", extra: "Confession 7:00 AM" },
  { day: "Saturday", time: "6:00 AM · 5:30 PM" },
];

const weekly = [
  { day: "Sunday", time: "9:30 AM", item: "Baptism" },
  { day: "Thursday", time: "2:00 PM", item: "Interview (Parish Office)" },
  { day: "Friday", time: "7:00 AM", item: "Confession & Holy Hour" },
  { day: "Saturday", time: "7:30 AM", item: "Wedding" },
  { day: "Saturday", time: "1:00 PM", item: "Funeral Mass" },
];

export default function Schedule() {
  return (
    <section id="schedule" className="py-24 md:py-36 bg-parchment-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel
          kicker="Worship & Liturgy"
          title="Mass & Sacrament Schedule"
          intro="Please confirm with the parish office for special celebrations, feast days, and occasional schedule changes."
        />

        <div className="mt-16 grid lg:grid-cols-12 gap-px bg-parchment-400">
          {/* Sunday */}
          <div className="lg:col-span-5 bg-parchment-50 p-8 md:p-10">
            <div className="text-[10px] uppercase tracking-[0.3em] text-terracotta font-sans mb-3">
              Sunday Schedule
            </div>
            <h3 className="font-serif text-3xl text-cocoa-900 mb-8">The Lord&rsquo;s Day</h3>

            <ul className="space-y-5">
              {sundayMasses.map((m) => (
                <li
                  key={m.time + m.label}
                  className="flex items-baseline gap-5 border-b border-parchment-400 pb-4 last:border-0"
                >
                  <span className="font-serif text-2xl text-terracotta w-28 flex-shrink-0">
                    {m.time}
                  </span>
                  <span className="font-sans text-cocoa-800 uppercase tracking-[0.15em] text-sm">
                    {m.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Daily */}
          <div className="lg:col-span-7 bg-parchment-100 p-8 md:p-10">
            <div className="text-[10px] uppercase tracking-[0.3em] text-sage-dark font-sans mb-3">
              Daily Mass Schedule
            </div>
            <h3 className="font-serif text-3xl text-cocoa-900 mb-8">Through the Week</h3>

            <ul className="grid md:grid-cols-2 gap-x-10 gap-y-3">
              {dailyMasses.map((d) => (
                <li
                  key={d.day}
                  className="flex items-baseline gap-4 border-b border-parchment-400 py-3"
                >
                  <span className="font-serif text-lg text-cocoa-900 w-28 flex-shrink-0">
                    {d.day}
                  </span>
                  <div className="flex-1">
                    <div
                      className={`font-sans text-sm ${
                        d.note ? "italic text-sage-dark" : "text-cocoa-800"
                      }`}
                    >
                      {d.time}
                    </div>
                    {d.extra && (
                      <div className="text-[11px] uppercase tracking-[0.18em] text-terracotta mt-0.5">
                        {d.extra}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Weekly Sacrament Schedule */}
        <div className="mt-12 bg-cocoa-900 text-parchment-100 p-8 md:p-10">
          <div className="grid md:grid-cols-12 gap-8 items-start">
            <div className="md:col-span-4">
              <div className="text-[10px] uppercase tracking-[0.3em] text-gold mb-3 font-sans">
                Weekly Sacrament Schedule
              </div>
              <h3 className="font-serif text-3xl">Recurring Celebrations</h3>
              <p className="mt-3 font-sans text-parchment-200/80 font-light text-sm leading-relaxed">
                Coordinate with the parish office to confirm before the scheduled day.
              </p>
            </div>

            <ul className="md:col-span-8 grid md:grid-cols-2 gap-x-10 gap-y-3">
              {weekly.map((w) => (
                <li
                  key={w.item + w.day}
                  className="flex items-baseline gap-4 border-b border-parchment-100/15 py-3"
                >
                  <span className="text-gold font-serif text-lg w-24 flex-shrink-0">
                    {w.day}
                  </span>
                  <span className="text-parchment-100 font-sans text-sm w-20 flex-shrink-0">
                    {w.time}
                  </span>
                  <span className="text-parchment-200/85 font-sans text-sm">
                    {w.item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-center font-sans text-sm text-cocoa-700 italic">
          ✦ GKK Masses and Bible Services are celebrated in respective chapels (see the Parish Calendar below).
        </p>
      </div>
    </section>
  );
}
